import { explainTrace } from "../engine/trace.js";
import type { ClassificationResult } from "../engine/engine.types.js";

/**
 * Dev/flag-gated only. Never imported by the public result screen. Enabled
 * by adding ?debug=1 to the URL (Incremento 1) — a real feature flag can
 * replace this later without changing the panel itself.
 */
export function isDebugEnabled(): boolean {
  return new URLSearchParams(window.location.search).get("debug") === "1";
}

export function renderTracePanel(container: HTMLElement, result: ClassificationResult): void {
  if (!isDebugEnabled()) return;
  const pre = document.createElement("pre");
  pre.className = "trace-panel";
  pre.setAttribute("aria-label", "Internal traceability panel (development only)");
  pre.textContent = explainTrace(result).join("\n");
  container.appendChild(pre);
}
